import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export interface SwTransData{
  idx : number;
  crw_idx : number;
  topic_cd : string;
  data_type_cd : string;
  created_date : string;
  seq : string;
  mgm_pk : string;
  issue_date : string;
  writer_ko : string;
  writer_sw : string;
  copyrighter_ko : string;
  copyrighter_sw : string;
  org_ext : string;
  data_src : string;

  url: string;
  kwd_sw: string;
  kwd_ko: string;
  kwd_en: string;
  title_sw: string;
  title_ko: string;
  title_en: string;
  text_sw: string;
  text_ko: string;
  text_en: string;

  wrd_cnt : string;
  file_size : string;
  
  prc_json : string;
  prc_yn : string;
  prc_date : string;
  
  isp1_user : string;
  isp1_yn : string;
  isp1_date : string;
  isp1_rsn : string;
  isp1_rsn_cd : string;
  
  isp2_user : string;
  isp2_yn : string;
  isp2_date : string;
  isp2_rsn : string;
  
  ins_date : string;

  instruction_yn : string;
}

export interface DetailCat{
  idx: number;
  crw_idx: number;
  
  kwd_sw: string;
  kwd_ko: string;
  kwd_en: string;
}

export interface DetailCrw{
  idx: number;
  site_name: string;
  url: string;
  title_sw: string;
  text_sw: string;
}

// const initailCatDetailData: DetailCat = {
//   idx: -1,
//   crw_idx: -1,
  
//   kwd_sw: "",
//   kwd_ko: "",
//   kwd_en: "",
// }


const initailSwTransData: SwTransData = {
  idx : -1,
  crw_idx : -1,
  topic_cd : "",
  data_type_cd : "",
  created_date : "",
  seq : "",
  mgm_pk : "",
  issue_date : "",
  writer_ko : "",
  writer_sw : "",
  copyrighter_ko : "",
  copyrighter_sw : "",
  org_ext : "",
  data_src : "",

  url: "",
  kwd_sw: "",
  kwd_ko: "",
  kwd_en: "",
  title_sw: "",
  title_ko: "",
  title_en: "",
  text_sw: "",
  text_ko: "",
  text_en: "",

  wrd_cnt : "",
  file_size : "",
  
  prc_json : "",
  prc_yn : "",
  prc_date : "",
  
  isp1_user : "",
  isp1_yn : "",
  isp1_date : "",
  isp1_rsn : "",
  isp1_rsn_cd : "",
  
  isp2_user : "",
  isp2_yn : "",
  isp2_date : "",
  isp2_rsn : "",
  
  ins_date : "",
  instruction_yn: "",
};

const initailInstructionData: any = {
  idx : -1,

  prc_idx : -1,
  // prc_topic_cd : "",
  
  // prc_title_sw: "",
  // prc_title_ko: "",
  
  // prc_text_sw: "",
  // prc_text_ko: "",
  topic_cd: "",
  
  answer: "",

  instruction_sw : "",
  instruction_ko : "",
  
  choice_sw_1: "",
  choice_sw_2: "",
  choice_sw_3: "",
  choice_sw_4: "",

  choice_ko_1: "",
  choice_ko_2: "",
  choice_ko_3: "",
  choice_ko_4: "",

  des:"",
  ins_worker:"",
  ins_date:"",
};

const TzaInstructionCreatePage = (props: any) => {

  const [prc_data, setPrc_data] = useState<SwTransData>(initailSwTransData);

  const [instruction_data, setInstruction_data] = useState<any>(initailInstructionData);

  const [instruction_detail_data, setInstruction_detail_data] = useState<any>(initailInstructionData);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [open_pop, setOpen_pop] = useState(false);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen_pop((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  const [pageType, setPageType] = useState("new")

  const [l_select, setL_select] = useState("KO")

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const worker = useSelector((state:any)=> state.userInfo.data.user.user_id)

  let union_role = auth.user.roles.some((obj:any) => ['TZA_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const getPrcDetail = async (idx: number) => {
    var result = await api.get("/sw-prc-detail",{params:{email:email,idx:idx}});
    setPrc_data(result.data.datas[0])
  };

  const getSwInstructionDetail = async (idx: number) => {
    var result = await api.get("/sw-instruction-detail",{params:{email:email,idx:idx}});
    // setPrc_data(result.data.datas[0])
    setInstruction_detail_data(result.data.datas[0])
  };

  const updateInstructionYn = async (v: boolean) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("idx", prc_data.idx.toString());

    formData.append("instruction_yn", (v == true ? "Y" : "N"));

    let alert_message = (v == true ? "Instruction 대상 설정 완료" : "Instruction 대상 해제 완료")

    // setPrc_data({ ...prc_data, topic_cd: e.target.value })

    await api.post("/sw-instruction-update",formData)
    .then((res:any) => { alert(alert_message); setPrc_data({ ...prc_data, instruction_yn: res.data }) })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})
  }

  const saveInstructionData = async () => {

    if(instruction_data.topic_cd == "None" || instruction_data.topic_cd == ""){
      alert('Instruction 주제분류 를 선택하세요.')
      return;
    }

    if(instruction_data.answer == "None" || instruction_data.answer == ""){
      alert('Answer 을 선택하세요.')
      return;
    }

    if((instruction_data.instruction_sw == "None" || instruction_data.instruction_sw == "") || (instruction_data.instruction_ko == "None" || instruction_data.instruction_ko == "")){
      alert('Instruction Question , 질문 은 필수입니다.')
      return;
    }

    if((instruction_data.choice_sw_1 == "None" || instruction_data.choice_sw_1 == "") 
      || (instruction_data.choice_sw_2 == "None" || instruction_data.choice_sw_2 == "")
      || (instruction_data.choice_sw_3 == "None" || instruction_data.choice_sw_3 == "")
      || (instruction_data.choice_sw_4 == "None" || instruction_data.choice_sw_4 == "")
      || (instruction_data.choice_ko_1 == "None" || instruction_data.choice_ko_1 == "")
      || (instruction_data.choice_ko_2 == "None" || instruction_data.choice_ko_2 == "")
      || (instruction_data.choice_ko_3 == "None" || instruction_data.choice_ko_3 == "")
      || (instruction_data.choice_ko_4 == "None" || instruction_data.choice_ko_4 == "")){
      alert('Instruction options , 선택항목 은 필수입니다.')
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("prc_idx", prc_data.idx.toString());

    formData.append("worker", worker);

    formData.append("instruction_data", JSON.stringify(instruction_data));

    // console.log('instruction_data', instruction_data)

    // return ;
    
    await api.post("/sw-instruction-insert",formData)
    .then((res:any) => { alert("Instruction 입력 완료"); getPrcDetail(props.rowDetail.idx); getSwInstructionDetail(props.rowDetail.idx); setPageType("update"); props.updateAfter();})
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }

  const updateInstructionDetailData = async () => {

    if(instruction_detail_data.topic_cd == "None" || instruction_detail_data.topic_cd == ""){
      alert('Instruction 주제분류 를 선택하세요.')
      return;
    }

    if(instruction_detail_data.answer == "None" || instruction_detail_data.answer == ""){
      alert('Answer 을 선택하세요.')
      return;
    }

    if((instruction_detail_data.instruction_sw == "None" || instruction_detail_data.instruction_sw == "") || (instruction_detail_data.instruction_ko == "None" || instruction_detail_data.instruction_ko == "")){
      alert('Instruction Question , 질문 은 필수입니다.')
      return;
    }

    if((instruction_detail_data.choice_sw_1 == "None" || instruction_detail_data.choice_sw_1 == "") 
      || (instruction_detail_data.choice_sw_2 == "None" || instruction_detail_data.choice_sw_2 == "")
      || (instruction_detail_data.choice_sw_3 == "None" || instruction_detail_data.choice_sw_3 == "")
      || (instruction_detail_data.choice_sw_4 == "None" || instruction_detail_data.choice_sw_4 == "")
      || (instruction_detail_data.choice_ko_1 == "None" || instruction_detail_data.choice_ko_1 == "")
      || (instruction_detail_data.choice_ko_2 == "None" || instruction_detail_data.choice_ko_2 == "")
      || (instruction_detail_data.choice_ko_3 == "None" || instruction_detail_data.choice_ko_3 == "")
      || (instruction_detail_data.choice_ko_4 == "None" || instruction_detail_data.choice_ko_4 == "")){
      alert('Instruction options , 선택항목 은 필수입니다.')
      return;
    }

    const formData = new FormData();

    formData.append("email", email);

    formData.append("prc_idx", prc_data.idx.toString());

    formData.append("worker", worker);

    formData.append("instruction_detail_data", JSON.stringify(instruction_detail_data));

    // console.log('instruction_detail_data', instruction_detail_data)

    // return ;
    
    await api.post("/sw-instruction-detail-update",formData)
    .then((res:any) => { alert("Instruction 수정 완료"); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error);})

  }


  useEffect(() => {
    getAuths();
    if(props.rowDetail != undefined){
      if(props.rowDetail.instruction_data == 'Y'){
        getPrcDetail(props.rowDetail.idx)
        getSwInstructionDetail(props.rowDetail.idx)
        setPageType("update")
      }else{
        getPrcDetail(props.rowDetail.idx)
        setInstruction_data(initailInstructionData);
        setPageType("new")
      }
    }
  }, [props.rowDetail]);

  if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (
    (pageType == "new" ?
    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Instruction 신규작성</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

          <Box display="flex">
            <>
            {l_select == "SW" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox>
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>SW</Box> */}
                          <Select id="l_select" value={l_select || "SW"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Utamaduni,Sanaa,Elimu</MenuItem>
                              <MenuItem dense value={"102"}>Historia,Jiografia,Utalii</MenuItem>
                              <MenuItem dense value={"103"}>Michezo,Nyingine</MenuItem>
                              <MenuItem dense value={"204"}>Jamii,Viwanda</MenuItem>
                              <MenuItem dense value={"205"}>Siasa,Uchumi</MenuItem>
                              <MenuItem dense value={"206"}>Sayansi,Dawa</MenuItem>
                              <MenuItem dense value={"307"}>Mila,Tambiko,Adabu</MenuItem>
                              <MenuItem dense value={"408"}>Maisha ya Kila Siku,Chakula</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_sw} spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_sw} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_sw} spellCheck="false" style={{width:"538px",minHeight:"434px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
            }
            {l_select == "KO" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox>
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                          <Select id="l_select" value={l_select || "KO"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                              <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                              <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                              <MenuItem dense value={"204"}>사회,산업</MenuItem>
                              <MenuItem dense value={"205"}>정치,경제</MenuItem>
                              <MenuItem dense value={"206"}>과학,의학</MenuItem>
                              <MenuItem dense value={"307"}>관습,의례</MenuItem>
                              <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_ko || ""} spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_ko || ""} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_ko || ""} spellCheck="false" style={{width:"538px",minHeight:"434px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
            {l_select == "EN" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox>
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                          <Select id="l_select" value={l_select || "EN"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                              <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                              <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                              <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                              <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                              <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                              <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                              <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_en || ""}  spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_en || ""} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_en || ""} spellCheck="false" style={{width:"538px",minHeight:"434px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
          </>
          



        {/* : ""} */}
        <Box sx={{margin:"2px",padding:"8px", border:"2px solid #000"}}>
          <Box sx={{padding:"10px", fontWeight:700, backgroundColor:"#000", color:"#fff"}}>INSTRUCTION</Box>
          <Box display="flex" >
            <Box>
              <Box display="flex" sx={{textAlign:"center", marginTop:"4px",alignItems: "center"}}>
                <Box sx={{padding:"8px",marginRight:"32px", fontWeight:700}}>주제분류</Box>
                <Select id="topic_cd" value={instruction_data.topic_cd || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"180px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                  <MenuItem dense value={""}>선택하세요</MenuItem>
                  <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                  <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                  <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                  <MenuItem dense value={"204"}>사회,산업</MenuItem>
                  <MenuItem dense value={"205"}>정치,경제</MenuItem>
                  <MenuItem dense value={"206"}>과학,의학</MenuItem>
                  <MenuItem dense value={"307"}>관습,의례</MenuItem>
                  <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                </Select>
              </Box>
              <Box display="flex" sx={{marginTop:"4px",alignItems: "center"}}>
                <Box sx={{marginLeft:"8px", fontWeight:700}}>ANSWER</Box>
                <Select id="answer" value={instruction_data.answer} onChange={(e) => {setInstruction_data({ ...instruction_data, answer: e.target.value });}} sx={{color:"green",width:"80px",height: "28px", marginLeft: "20px", border:"2px solid #498ad5", borderRadius:"4px"}}>
                  <MenuItem dense value={"A"}>A</MenuItem>
                  <MenuItem dense value={"B"}>B</MenuItem>
                  <MenuItem dense value={"C"}>C</MenuItem>
                  <MenuItem dense value={"D"}>D</MenuItem>
                </Select>
              </Box>
              <Box sx={{display:"flex", marginTop:"4px"}}>
                <Box sx={{display:"flex",marginLeft:"4px"}}>
                  <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                  <Box><textarea value={instruction_data.des || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, des: e.target.value });}} style={{width:"386px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{width:"100%", marginTop: "16px"}}>
              <Box display="flex" justifyContent="center">
                <Button variant="contained" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"180px",height:"80px"}}
                  onClick={() => {
                    saveInstructionData();
                  }}
                >
                  저 장
                </Button>
              </Box>
            </Box>
          </Box>


          <Box sx={{display:"flex"}}>
            <Paper sx={{padding:"4px", marginTop:"8px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>SW</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={instruction_data.instruction_sw || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, instruction_sw: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={instruction_data.choice_sw_1 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_sw_1: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={instruction_data.choice_sw_2 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_sw_2: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={instruction_data.choice_sw_3 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_sw_3: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={instruction_data.choice_sw_4 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_sw_4: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginLeft:"12px", marginTop:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>질문</Box>
                      <Box><textarea spellCheck="false" value={instruction_data.instruction_ko || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, instruction_ko: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>선택항목</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={instruction_data.choice_ko_1 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_ko_1: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={instruction_data.choice_ko_2 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_ko_2: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={instruction_data.choice_ko_3 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_ko_3: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={instruction_data.choice_ko_4 || ""} onChange={(e) => {setInstruction_data({ ...instruction_data, choice_ko_4: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>

        </Box>
        </Box>
      </Box>

    </Paper>
    :
    <Paper sx={{width:"100%", overflow: "auto"}}>
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Instruction 수정</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box display="flex">

          <Box display="flex">
            <>
            {l_select == "SW" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          {/* <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox> */}
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>SW</Box> */}
                          <Select id="l_select" value={l_select || "SW"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Utamaduni,Sanaa,Elimu</MenuItem>
                              <MenuItem dense value={"102"}>Historia,Jiografia,Utalii</MenuItem>
                              <MenuItem dense value={"103"}>Michezo,Nyingine</MenuItem>
                              <MenuItem dense value={"204"}>Jamii,Viwanda</MenuItem>
                              <MenuItem dense value={"205"}>Siasa,Uchumi</MenuItem>
                              <MenuItem dense value={"206"}>Sayansi,Dawa</MenuItem>
                              <MenuItem dense value={"307"}>Mila,Tambiko,Adabu</MenuItem>
                              <MenuItem dense value={"408"}>Maisha ya Kila Siku,Chakula</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_sw} spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_sw} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_sw} spellCheck="false" style={{width:"538px",minHeight:"460px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
            }
            {l_select == "KO" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          {/* <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox> */}
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box> */}
                          <Select id="l_select" value={l_select || "KO"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                              <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                              <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                              <MenuItem dense value={"204"}>사회,산업</MenuItem>
                              <MenuItem dense value={"205"}>정치,경제</MenuItem>
                              <MenuItem dense value={"206"}>과학,의학</MenuItem>
                              <MenuItem dense value={"307"}>관습,의례</MenuItem>
                              <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_ko || ""} spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_ko || ""} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_ko || ""} spellCheck="false" style={{width:"538px",minHeight:"460px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
            {l_select == "EN" && <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#f1d4d9"}}>
                <Box sx={{width:"558px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"left"}}>
                          <Box sx={{fontSize:"14px",fontWeight:700, width:"40px"}}>idx</Box>
                          <Box sx={{fontSize:"14px", width:"80px"}}>{prc_data.idx}</Box>
                          {/* <Box sx={{marginLeft:"16px", fontSize:"14px", fontWeight:700}}>Instruction 대상</Box>
                          <Checkbox style={{ color: '#da33f0' }} checked={prc_data.instruction_yn == 'Y'? true : false} onClick={(e:any)=> {updateInstructionYn(prc_data.instruction_yn == 'Y'? false : true); }}></Checkbox> */}
                        </Box>
                        <Box sx={{display:"flex", alignItems:"center", justifyContent:"center"}}>
                          {/* <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>EN</Box> */}
                          <Select id="l_select" value={l_select || "EN"} onChange={(e) => {setL_select(e.target.value );}} sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>
                              <MenuItem dense value={"SW"}>SW</MenuItem>
                              <MenuItem dense value={"KO"}>KO</MenuItem>
                              <MenuItem dense value={"EN"}>EN</MenuItem>
                            </Select>
                          <Box sx={{marginLeft:"16px"}}>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>주제분류 (TOPIC)</Box>
                            <Select id="topic_cd" value={prc_data.topic_cd || "101"} onChange={(e) => {setPrc_data({ ...prc_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"408px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                              <MenuItem dense value={"101"}>Culture,Arts,Education</MenuItem>
                              <MenuItem dense value={"102"}>History,Geography,Tourism</MenuItem>
                              <MenuItem dense value={"103"}>Sports,Other</MenuItem>
                              <MenuItem dense value={"204"}>Society,Industry</MenuItem>
                              <MenuItem dense value={"205"}>Politics,Economy</MenuItem>
                              <MenuItem dense value={"206"}>Science,Medicine</MenuItem>
                              <MenuItem dense value={"307"}>Custom,Ritual</MenuItem>
                              <MenuItem dense value={"408"}>Daily Life,Food</MenuItem>
                            </Select>
                            <Box sx={{margin:"8px 0px 0px 2px", fontWeight:700}}>키워드 (KEYWORD)</Box>
                            <Box><textarea readOnly value={prc_data.kwd_en || ""}  spellCheck="false" style={{width:"408px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>
                          </Box>
                        </Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_en || ""} spellCheck="false" style={{width:"538px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_en || ""} spellCheck="false" style={{width:"538px",minHeight:"460px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>}
          </>
          



        {/* : ""} */}
        <Box sx={{margin:"2px",padding:"8px", border:"2px solid #000"}}>
          <Box sx={{padding:"10px", fontWeight:700, backgroundColor:"#4fcb38", color:"#fff"}}>INSTRUCTION</Box>
          <Box display="flex" >
            <Box>
              <Box display="flex" sx={{textAlign:"center", marginTop:"4px",alignItems: "center"}}>
                <Box sx={{padding:"8px",marginRight:"32px", fontWeight:700}}>주제분류</Box>
                <Select id="topic_cd" value={instruction_detail_data.topic_cd || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, topic_cd: e.target.value });}} sx={{backgroundColor: "#fff",color:"green",width:"180px", height: "28px", marginRight: "16px", border:"2px solid #498ad5", padding: "2px 6px 2px 6px", borderRadius:"4px"}}>
                  <MenuItem dense value={""}>선택하세요</MenuItem>
                  <MenuItem dense value={"101"}>문화,예술,교육</MenuItem>
                  <MenuItem dense value={"102"}>역사,지리,관광</MenuItem>
                  <MenuItem dense value={"103"}>스포츠,기타</MenuItem>
                  <MenuItem dense value={"204"}>사회,산업</MenuItem>
                  <MenuItem dense value={"205"}>정치,경제</MenuItem>
                  <MenuItem dense value={"206"}>과학,의학</MenuItem>
                  <MenuItem dense value={"307"}>관습,의례</MenuItem>
                  <MenuItem dense value={"408"}>일상생활,음식</MenuItem>
                </Select>
              </Box>
              <Box display="flex" sx={{marginTop:"4px",alignItems: "center"}}>
                <Box sx={{marginLeft:"8px", fontWeight:700}}>ANSWER</Box>
                <Select id="answer" value={instruction_detail_data.answer} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, answer: e.target.value });}} sx={{color:"green",width:"80px",height: "28px", marginLeft: "20px", border:"2px solid #498ad5", borderRadius:"4px"}}>
                  <MenuItem dense value={"A"}>A</MenuItem>
                  <MenuItem dense value={"B"}>B</MenuItem>
                  <MenuItem dense value={"C"}>C</MenuItem>
                  <MenuItem dense value={"D"}>D</MenuItem>
                </Select>
              </Box>
              <Box sx={{display:"flex", marginTop:"4px"}}>
                <Box sx={{display:"flex",marginLeft:"4px"}}>
                  <Box sx={{margin:"8px 12px 0px 4px",width:"32px", fontWeight:700}}>비고</Box>
                  <Box><textarea value={instruction_detail_data.des || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, des: e.target.value });}} style={{width:"386px",minHeight:"40px", fontSize:"14px", fontWeight:600,padding:"2px"}}  /></Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{width:"100%", marginTop: "16px"}}>
              <Box display="flex" justifyContent="center">
                <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"8px 16px",width:"180px",height:"80px"}}
                  onClick={() => {
                    updateInstructionDetailData();
                  }}
                >
                  수 정
                </Button>
              </Box>
            </Box>
          </Box>


          <Box sx={{display:"flex"}}>
            <Paper sx={{padding:"4px", marginTop:"8px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>SW</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Question</Box>
                      <Box><textarea spellCheck="false" value={instruction_detail_data.instruction_sw || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, instruction_sw: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>Options</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={instruction_detail_data.choice_sw_1 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_sw_1: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={instruction_detail_data.choice_sw_2 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_sw_2: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={instruction_detail_data.choice_sw_3 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_sw_3: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={instruction_detail_data.choice_sw_4 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_sw_4: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>

            <Paper sx={{padding:"4px", marginLeft:"12px", marginTop:"16px", border:"3px solid #3e36a5"}}>
              <Box sx={{width:"420px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{marginLeft:"4px"}}>
                    <Box sx={{fontSize:"28px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                      <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>질문</Box>
                      <Box><textarea spellCheck="false" value={instruction_detail_data.instruction_ko || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, instruction_ko: e.target.value });}} style={{width:"410px",minHeight:"120px", fontSize:"16px",padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box sx={{width:"420px",margin:"4px"}}>
                <Box sx={{margin:"8px 0px 0px 2px", color:"#4664b4", fontWeight:700}}>선택항목</Box>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "A" ? "red" : "#000")}}>A</Box>
                    <Box><textarea spellCheck="false" value={instruction_detail_data.choice_ko_1 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_ko_1: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                    <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "B" ? "red" : "#000")}}>B</Box>
                    <Box><textarea spellCheck="false" value={instruction_detail_data.choice_ko_2 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_ko_2: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "C" ? "red" : "#000")}}>C</Box>
                  <Box><textarea spellCheck="false" value={instruction_detail_data.choice_ko_3 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_ko_3: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
              <Box sx={{width:"350px",margin:"4px"}}>
                <Box sx={{display:"flex", alignItems:"center"}}>
                  <Box sx={{marginLeft:"8px", display:"flex", alignItems:"center"}}>
                  <Box sx={{width:"24px", margin:"8px 0px 0px 2px", fontWeight:700, color:(instruction_detail_data.answer === "D" ? "red" : "#000")}}>D</Box>
                  <Box><textarea spellCheck="false" value={instruction_detail_data.choice_ko_4 || ""} onChange={(e) => {setInstruction_detail_data({ ...instruction_detail_data, choice_ko_4: e.target.value });}} style={{width:"372px",minHeight:"60px", fontSize:"14px", fontWeight:600,padding:"2px", fontFamily: "Noto Sans KR"}}  /></Box>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>

        </Box>
        </Box>
      </Box>

    </Paper>
      )
  );
  
  
};

export default TzaInstructionCreatePage;
